export default "__VITE_ASSET__BWun3zI9__"